import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { ScheduleAction } from '../../schedule.action';

export const ScheduleListSubscriber: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ScheduleAction.loadList.started({}));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(ScheduleAction.destroy());
    };
  }, [dispatch]);

  return null;
};
